import img2008241 from './../assets/news/content/20-08-24-1.png'
import img2008242 from './../assets/news/content/20-08-24-2.png'
import img210824 from './../assets/news/content/21-08-24.png'
import img020924 from './../assets/news/content/02-09-24.png'
import confer from './../assets/news/content/03-10-24.jpg'
import device from './../assets/news/news-08-07-2025.png';
import battery from './../assets/news/news-03-07-2025.png';
import image020725 from './../assets/news/news-02-07-2025.png';
import image1 from './../assets/news/image1.png';
import image2 from './../assets/news/image2.png';
import image3 from './../assets/news/image3.png';
import bajc1 from './../assets/news/content/BAJC-1.png';
import bajc2 from './../assets/news/content/BAJC-2.png';
import bajc3 from './../assets/news/content/BAJC-3.png';
import bajc4 from './../assets/news/content/BAJC-4.png';
import bajc5 from './../assets/news/content/BAJC-5.png';
import china1 from './../assets/news/content/china-1.png';
import chian2 from './../assets/news/content/china-2.png';
import certificate from './../assets/news/content/certificate.png';
import WSU1703 from './../assets/news/content/17-03-2026WSU.png';
import conference021026 from './../assets/news/content/02-10-26.JPG';

export const newsDetail = [
  {
    date: "20 August 2024",
    description: "Distinguished Visitor of the Centre: Professor Yuanping Cheng of China University of Mining and Technology (CUMT) 's visit",
    content: 
    <>

      <div>
        Distinguished Professor Yuanping Cheng of China University of Mining and Technology (CUMT) visited the Australian Research Council (ARC)-Industrial
          Transformation Training Centre (ITTC) for Innovative Composites for the Future of
          Sustainable Mining Equipment on the afternoon of 20th August. Distinguished Professor Cheng
          is a globally known expert and scholar in coal mine methane and safety engineering in mining.
          He has been granted over 30 Chinese invention patents, published 8 academic monographs,
          and has authored more than 230 papers indexed by SCI and over 90 papers indexed by EI. 
      </div>

      <div>
        CUMT and UOW have enjoyed a fruitful partnership spanning over 14 years, resulting
    in more than 70 joint publications in top-quality journals and international conferences. This
    collaboration has also led to joint research projects, industry-driven initiatives, and the cohosting of international symposia and conferences, including the Green Mining Conference.
      </div>

    <div>
    The visit was facilitated by Professor Ting Ren, Deputy Director of ARC Training
  Centre, and featured a workshop attended by Professor Xueqiu He, a visiting professor at UOW
  and an advisory committee member of ARC Training Centre, along with several HDR students.
  </div>

  <div>
    During the workshop, Distinguished Professor Yuanping Cheng delivered a compelling
  presentation titled “Micropore Filling of Gas and New Classification Methods of Pore
  Structures in Coal”. His presentation covered key aspects of his research, including
  advancements in understanding complex pore structures in coal, gas occurrence characteristics,
  and the latest methods for characterising and classifying new pore types, highlighting the
  significance of these findings for both research and engineering applications
  </div>

  <div>
    PhD Candidate Ming Cheng followed with a presentation on “Precise Evaluation of
  Fracture Porosity of Coal Body: Key Factor in Assessing Free Gas Outburst Expansion Energy”.
  Professor Ting Ren then shared insights from recent research on gas rapid sorption tests, new
  findings related to gas expansion energy, the impact of rapid gas desorption on coal structure,
  as well as the difference between normal and tight coal in terms of mineral contents and
  fractures
  </div>

    <div>
    The workshop also included engaging discussions on techniques for differentiating
  normal and tight coal, as well as technologies aimed at reducing the risks of coal and gas
  outbursts. The event concluded with a focus on potential future collaborations between CUMT
  and UOW.
  </div>

<div>
    Following the workshop, Distinguished Professor Yuanping Cheng visited the ARC
  Training Centre in Building 4, where he engaged with HDR students and postdoctoral fellows,
  fostering further academic exchange and collaboration.
  </div>
    <img src={img2008241} alt='meeting-img-1' className='w-4/5'/>
    <img src={img2008242} alt='meeting-img-1' className='w-4/5'/>
  </>
  },
  {
    date: "9 August 2024",
    description: "Use manufacturing technologies to achieve 2050 net zero carbon target in a rural setting",
    content: 
    <>
      <div>
      On 9 Aug, the CEO and her team from a large local manufacturing firm, VLI Conveyors Industrial Technology
Pty Ltd (VLIC) visited the ARC innovative composites and mining equipment (the Centre) and the research
team led by the Centre Director, Distinguished Professor Zhengyi Jiang.
      </div>
      <div>
      VLIC have been supplying specialist mining facilities/equipment and related services to the local resources
industry for more than 30 years. VLIC provides a comprehensive and diverse range of facilities/equipment
including rollers, drilling rigs, mining equipment, rock cutting tools, industry pump and conveyor systems, all
designed and manufactured by our own team to the highest specifications. VLIC, we aims to provide industryleading technology, innovation and service solutions to all of its customers. 
      </div>
      <div>
      UOW, through the research team led by Distinguished Professor Jiang, is equipped with world class facilities
such as Hille 1000 rolling mill and MFT-5000 Multi-functional Tribometer, industry focused minds, and have
produced forefront research outcomes in material design and its manufacturing technologies.
      </div>
      <div>
      At the initial official meeting between VLIC and the Centre on 9 Aug, a mutual interest was developed and
discussed. The activities will include: to develop innovative methods using novel composites, to explore
manufacturing technologies to produce rollers, conveyor systems and rock cutting tools with reduced weights, to
enhance wear and corrosion resistance, and to make the facilities/equipment more efficiently, less energy
consumptions and with reduced operational costs for manufacturing and mining equipment industry. The
outcomes of the proposal will transform the delivery to wide range of customers in rural and local setting
especially, and help achieve our 2050 net zero carbon target and secure the sustainable future of manufacturing
transportation industry
      </div>
      <div>
      VLIC is also interested in being part of the team to facilitate HDR training, workshops and field trips to its industry
customers sites. Both the Center and VLIC will surely benefit from the proposed research collaboration and
engagement activities.
      </div>
      <div>
      VLIC visitors also visited UOW’s forefront research labs on the main campus. The visit concluded with a
      resounding success in the early afternoon on 9 Aug. 
      </div>

    </>
  },
  {
    date: "21 June 2024",
    description: "The world's largest steel producer funds UOW to undertake low carbon emission research projects",
    content: <>
      <div>
      On the afternoon of 21 June, a senior delegation from BaoWu and Baosteel Australia Joint
Research and Development Centre (BAJC) visited the ARC ITTC Innovative Composites for the
Future of Sustainable Mining Equipment at UOW. BaoWu is the largest steel producer in the
world by volume (2023). 
      </div>
      <div>
      The delegation was comprised of the core leadership team of Baosteel. They included Mr Jixin
Zou (Chairman, Baosteel), Mr Changdeng Qin (General Manager, Strategy & Planning Dept.,
and Director, Sci & Tech. Innovation Dept., BaoWu), Dr Jun Wu (Vice President, and Director of
Central Research Institute, Baosteel), Mr Yunyong Liu (Director, Administrative Office,
Baosteel), Mr Yongzhu Ma (Technical Director, Center for Basic Research and Applied
Innovation, Baosteel), Mr Yijun Shen (General Manager, Baosteel Australia), and Mr Puchun
Zheng (Sales Manager, Baosteel Australia). The delegation also included Professor Geoff Wang
(Director of BAJC, UQ).
      </div>
      <div>
      UOW attendees included Senior Professor Eileen McLaughlin (Acting DVC(R&SF)),
Distinguished Professor Zhengyi Jiang, (Director, ARC ITTC Innovative Composites for the
Future of Sustainable Mining Equipment), Ms Sharon Martin (Director, Research Services
Office), Mr Stefan Delfgou (Associate Director, Research Services Office), Senior Professor
Michel , Philip, Jiaotao, Senior Professor Huijun Li (Associate Dean (HDR), EIS), Matin…Other
EIS colleagues and management team members, and colleagues from the UOW Global Strategy
Division also attended the meeting with the delegation. 
      </div>
      <div>
      BAJC is a world-first joint venture between Baosteel and four Australian universities (the
University of Queensland, the University of New South Wales, Monash University and the
University of Wollongong). Established in 2011, it seeks to create an enduring collaboration
between Baosteel and these Australian universities, and to conduct research and provide
innovative technologies in areas of interest to Baosteel. Following the merger between Baosteel
and the Wuhan Iron & Steel Group, BAJC welcomed Deakin University as another participant in
February 2019. Based at the University of Queensland, BAJC has been exploring and developing
new knowledge and technologies in selected areas of particular significance for Baosteel's longer
term, strategic development and business activities.
      </div>
      <div>
      In last 2 years, the BAJC Board approved 18 projects with total Baosteel funding of over $3M
commencing in January 2023. Five of these projects were granted to UOW EIS researchers.
These projects are:
        <ul className='list-disc pl-8'>
          <li>
          The application of autonomous multi-agent technology in intelligent modelling,
optimization, decision-making and simulation of the steel manufacturing.
</li>
<li>
Formability and forming simulation of novel super ferritic stainless steel bipolar plate
applied in hydrogen fuel cell.
</li>
          <li>
          A BDI agent platform for smart modelling and integrated simulation of production
          scheduling, cargo loading, and logistics in the steel industry.
          </li>
          <li>
          Mechanism and practical research on surface quality improvement of hot rolled plate
          steels under high chloridoid water based nano lubrication.
          </li>
          <li>
Investigating solidification defects and improving quality of nitrogen-bearing steel using
electric furnace smelting and continuous casting.
          </li>
        </ul>
        BAJC is currently a key industry partner for the ARC Training Centre for Innovative Composite
for the Future of Sustainable Mining Equipment, led by UOW’s Distinguished Professor Zhengyi
Jiang. Following the meeting with the UOW management team, Professor Jiang took the
delegation to visit UOW’s forefront rolling, welding and manufacturing research labs, and also showcased industry-relevant results from projects funded by Baosteel during the lab
demonstrations. The projects relate to ironmaking, steelmaking, steel rolling, energy pipelines,
mining, and AI.
      </div>
      <div>
      As Professor Jiang mentioned during the lab demonstrations, “the outcomes of these industry
projects not only promote the application of innovative technologies and the development of new,
high value and low carbon emission products in Baosteel, but have also strengthened the academic
and industry collaborations and provided tangible benefits to both industry and participating
Australian universities.
      </div>
    </>
  },
  {
    date: "21 August 2024",
    description: "The Centre welcomed the Dean of Engineering from Curtin University.",
    content: <>
    <div>
    On 21 Aug, the Dean of Engineering at Curtin University and Chief Investigator (CI) of ARC Innovative
Composites for Sustainable Mining Equipment (the Centre), Professor Vishnu Pareek visited the
Centre.
    </div>
    <div>
    Professor Vishnu Pareek’s expertise lies in process simulations and design, with a particular
emphasis in applying these tools to industrial-scale problems. He has conducted extensive applied
research/consultancy for several multinational companies such as Chevron, Woodside and BP. In
2019, he was awarded the title of John Curtin Distinguished Professor for his excellence in research
and academic leadership. Vishnu’s expertise and leadership play an important role for the Centre’s
Program three, which focuses on Artificial Intelligence based and Data driven solutions for mining
equipment utilisation. During the half day visit, Vishnu had a meeting with the Centre’s Director,
Distinguished Professor Zhengyi Jiang, Deputy Director Professor Ting Ren and the Business Manager
in Centre head office, R109 Building 4. Vishnu advised the progress of the project at Curtin
University. A high quality ICHDR candidate has been secured and is scheduled to enrol later this year
at Curtin University. The group also discussed Centre ICHDR candidates’ activities in October 2024
and 2025 plans.
    </div>
    <div>
    Following the Centre business meeting, Vishnu was invited to UOW’s Café Hemingway in building 67
for a sunny work lunch before meeting with ED of EIS, Professor Gursel Alici. Professor Vishnu
Pareek headed back to Canberra later in the afternoon.
    </div>
    <img src={img210824} alt='visiting' />
    </>
  },
  {
    date: "2 September 2024",
    description: "A new industry partner joined ARC Innovative Composites for Sustainable Mining Equipment.",
    content: <>
      <div>
      On 2 Sept ARC Innovative Composites for the Future of Sustainable Mining Equipment (the Centre)
headquartered at University of Wollongong (UOW) Director Distinguished Professor Zhengyi Jiang
and Deputy Director Professor Ting Ren welcomed a delegation comprised of Dr Liang Zhao,
Yunpeng Wang, and Shuangcheng Dai, from Azure Mining Technology (AMT) Pty Ltd.
      </div>
      <div>
      Joined the Centre earlier this year, AMT became the latest addition to the Centre’s Partner
Investigator team (PI), contributing both industry expertise and cashing funding. AMT is a subsidiary
of China Coal Technology and Engineering Group (CCTEG). CCTEG started from exporting complete
sets of coal mining equipment, the company has grown into a comprehensive international supplier
of EPC project, technological and engineering services. The Company is committed to bringing the
leading-edge technical advantages to the world, particularly in the fields of technology and planning,
coal engineering, coal mining equipment, coal mining safety, cola chemical industry, clean energy
and environmental protection. CCTEG also provide complete sets of equipment and technical
solutions for global coal enterprises with high-quality, reliable and safety services.
      </div>
      <div>
      During the visit, the AMT delegation visited the Centre head office located in R109 Building 4, a
number of research forefront labs and UOW main campus. A very productive discussion was held on
a number of joint research projects to be undertaken in the next three to four years. The team also
discussed the avenues and expected outcomes to co mentor the Centre ICHDR candidates and
young professionals.
      </div>
      <div>
      The delegates finished on a highly positive note that AMT and the Centre will continue the
      collaborative work on developing future technology for green mining and energy.
      </div>
      <img src={img020924} alt='news-020924' />
    </>
  },
  {
    date: "3 October 2024",
    description: "Green Mining Conference 2024 and First HDR Forum of ARC ITTC for Innovative Composites for Sustainable Mining. ",
    content: 
      <>
        <div>
          The ARC ITTC for Innovative Composites for the Future of Sustainable Mining Equipment (the Centre) has successfully hosted Green Mining Conference 2024 held at the University of Wollongong from 1 to 3 October. UOW’s Interim Vice Chancellor, Professor John Dewar, Centre Director Distinguished Professor Zhengyi Jiang, and Deputy Director, Professor Ting Ren delivered opening speeches and welcomed over 150 attendees from NSW, interstate and overseas. Professors Jixiong Zhang (Vice-president, China University of Mining and Technology, Hairong Dong (Vice-president, Shandong University of Science and Technology), and Xikui Sun (Chief Engineer, Shandong Energy Group) also delivered their respective opening addresses. UOW’s PVC (Impact) Professor Bradley Williams was the MC for the Conference Opening Ceremony.
        </div>
        <div>
          In his opening speech, Distinguished Professor Zhengyi Jiang indicated that “The Mining Equipment, Technology and Service (METS) sector contributes $92 billion to the Australian economy, provides over half a million jobs, and has an average growth rate of 7%. The METS sector will require a diverse and flexible workforce of highly skilled engineers with innovative thinking and broad knowledge of future technologies, economic and commercialisation opportunities, and environmental and social responsibilities.” Therefore “As sustainable mining operations become more common in the future, we need innovative composites to manufacture the desired mining equipment, such as mining trucks and mining pumps, to produce mining products to drive the renewable energy transition.” said Professor Jiang.
        </div>
        <div>
          The Conference has held two Keynote Plenary Sessions and six parallel sessions on Day 2 and Day 3 respectively. The talks over the two day conference included a wide range of mining industry challenges such as risk management, health and safety, current status and technology, green and low carbon technology in coal mining, innovative composites (for simulated mining testing rig) and use of AI in mining industry. As Deputy Director Professor Ting Ren said “these exchanges/discussions are vital to driving progress in min hazard prevention and control, for a greener and more sustainable industry for the future” 
        </div>
        <div>
          As part of the conference, the HDR forum on 3 Oct, focused in particular on young professionals’ practical and academic skill development. There were thirty HDR presentations during the Forum, including those students commenced in Sept 2024. Six HDR students won “best presentation awards” at the 1st HDR forum of ARC ITTC innovative composites for sustainable mining equipment. Centre Director Zhengyi Jiang presented the certificates and token gifts to the exciting HDR students (awardees).
        </div>
        <div>
          The Green Mining Conference 2024 provided great opportunities for researchers, engineers and higher degree research students to exchange current ideas in green mining technology worldwide, and to provide advice to solve challenges in the mining industry. 
        </div>
        <div>
          The Conference Gala Dinner was held at City Beach Function Centre on 2 Oct. The Conference registration commenced on the evening of 1 Oct, and concluded with a very positive note on 3 Oct. 
        </div>
        <div>
          The Conference also features a sideline meeting on 2 Oct chaired by UOW’s Interim DVC (Research and Sustainable Futures), Senior Professor Eileen McLaughlin, and post conference technical tours to Coal Services and Green Gravity on the morning of 4 Oct, both of which are the Illawarra community companies.  
        </div>
        <img src={confer} alt='conference' className='w-4/5 m-auto' />
      </>
  },
  {
    date: "2 July 2025",
    description: "Zhengzhou University visit",
    content: <>
        <img src={image020725} alt='news-020725'  className='w-1/3 m-auto'  />
    <div>
    Zhengzhou University visit ARC Centre for Innovative Composites for Sustainable Mining
Equipment
</div>
<div>
On 2 July a senior delegation from School of Materials Science and Engineering, Zhengzhou
University, China visited ARC Centre for Innovative Composites for Sustainable Mining
Equipment. Zhengzhou University attendees included Professors Ruibo Wang, Shihao Li, Youxin
Ji, Fangru Wang and Dr Wenjie Zhang. UOW ATTENDEES were ARC Centre Director,
Distinguished Professor Zhengyi Jiang, Professor Jiangtao Xi, Associate Dean (Global
Engagement), Faculty of Engineering and Information Sciences, Ms Lily An, Senior Manager, and
Mr Thomas Quinn, Senior Coordinator, International Engagement &amp; Coordination, Global
Strategy.
</div>
<div>
Professor Jiangtao Xi led the discussion of future students, faculty exchange and joint research
platform and projects and funding proposals in the fields of various materials engineering
disciplines. The discussions took place in the Boardroom of SMART building. Following the
morning meeting, the delegation undertook a lab tour at ARC Centre for Innovative Composites
for Sustainable Mining Equipment.
</div>
<div>
One of the immediate outcomes is that Zhengzhou University will shortly renew an agreement
with UOW for joint education programs.
    </div>
    </>
  },
  {
    date: "3 July 2025",
    description: "Bao Steel Researcher visit",
    content: 
    <>
        <img src={battery} alt='news-03-07-25'  className='w-1/3 m-auto'  />
    <div>
    Researcher from Baosteel paid a technical visit to UOW advanced micromanufacturing lab at ARC
    Centre for Innovative Composites for Sustainable Mining Equipment
    </div>
      <div>
      From 30 June to 3 July, ARC Centre for Innovative Composites for Sustainable Mining Equipment
welcomed Baosteel researcher Dr Zhixia Zhang. During her stay at UOW, Dr Zhang conducted
milestone experiments for a collaborative research project funded by Baosteel via BAJC and
undertaken at ARC Centre. In addition to collecting UOW manufacturing simulated data, analysing
the data and completing associated experiments Dr Zhang also attended HDR students and
researchers’ seminar, presented her own work for BAJC UOW project #3, and discussed a potential
new BAJC funding directions with the Centre Director and Centre postdoctoral fellows.
      </div>
      <div>
      Centre students and fellows also took Dr Zhang to visit the pristine Wollongong beach and other
      breathtaking local sites during her short stay at UOW.
      </div>
    </>
  },
  {
    date: "8 July 2025",
    description: "Jiangsu Industrial Technology Research Institute visit",
    content: 
      <>
        <img src={device} alt='08-07-25' className='w-4/5 m-auto' />
      <div>
              From 7 – 8 July 2025 a delegation comprised of National Innovation Center Par Excellence
        (NICE), Jiangsu Industrial Technology Research Institute (JITRI), and Wuxi Industrial Innovation
        Research Institute (WIIRI) visited UOW. NICE is a national innovation platform jointly
        developed by the municipal government of Shanghai and the provinces of Jiangsu, Zhejiang, and
        Anhui. Headquartered at the Shanghai Yangtze Delta Innovation Institute (SYDII). NICE has
        established numerous specialised research institutes and technology innovation centres that
        directly support industrial transformation across China. Globally, NICE partners with some
        world leading institutions such as UNSW, the University of Sydney, Monash University, and
        CSIRO.
      </div>
      <div>
      Led by Professor Liu Qing, President of NICE and JITRI, the delegation comprised of a group of
internationally renowned researchers across STEM, Biology, and Medicine, representing some
of China’s most dynamic research and innovation ecosystems. On 7 July UOW’s VC , Professor
Max Lu AO, welcomed the delegation in Council Room Building 36. The delegation had group
discussions with UOW senior executives and researchers from SMAH and EIS. Attendees from
NICE, JITRI, WIIRI were Professor Qing Liu, President, NICE/JITRI; Dr Qian Li, Deputy Director,
Advanced Materials Department, NICE/JITRI; Dr Luhuan Fan, Deputy Director, Engineering
Education and Domestic Cooperation Department, NICE/JITRI; Dr Hao Zhang, Assistant
Director, Overseas Cooperation Department, NICE/JITRI; Mr Jian Li, Assistant Director, Energy
and Environmental Protection Department, NICE/JITRI; Dr Xiang Zuo, Business Manager,
Information and Communication Technology Department, NICE/JITRI; Dr Yidong Hu, President,
WIIRI; Mr Liran Liu, Business Manager, WIIRI and Dr Erjiang Fu, Chairman, Australia-China
Association of Scientists and Entrepreneurs. Attendees from UOW included Professor G.Q. Max
Lu AO, Vice-Chancellor and President, Senior Professor Gursel Alici, Executive Dean, EIS,
Professor Adam Trevitt, Executive Dean (Acting), SMAH, Distinguished Professor Gordon
Wallace AO, Director, ARC Centre for Excellence for Electromaterials Science, Distinguished
Professor Xu-Feng Huang, NHMRC Research Leadership Fellow, SMAH, Distinguished Professor
Willy Susilo, ARC Laureate Fellow, Director, Institute of Cybersecurity and Cryptology, EIS,
Distinguished Professor Zhengyi Jiang, Director, ARC Training Centre for Innovative Composites
for the Future of Sustainable Mining Equipment EIS, and other researchers and colleagues from
EIS, SMAH and International unit.
      </div>
      <div>
      On 7 July and post the executive group discussions, Prof Liu Qing and the delegation undertook
a series of lab tours to some of the UOW’s top notch research labs including one of the world
leading manufacturing research labs established and led by ARC Centre Director, Distinguished
Professor Zhengyi Jiang. During this lab tour, Professor Jiang introduced many forefront
facilities, such as bimetal wear-resistant composite plates (BWRCPs), which was jointly
designed and developed with Baoshan Iron &amp; Steel Co. Ltd (Shanghai, China). The two types of
BWRCPs, AH36/2205 and Mn8/SS400 both of which incorporated new bimetal composites, are
being used as an ideal alternative to generate wear resistant, heavy duty and cost effective steel
products for dump truck beds and scraper conveyor chutes in mining industry. Another state-
of-the-art facility in Prof Jiang’s manufacturing lab is the advanced rolling mills including macro
and micro capacities. At UOW, over the past 25 years Prof. Jiang has led the comprehensive
Rolling Mechanics research group to systematically build a series of technically innovative
rolling mills for steel making and metal fabrication from macro to micro scale/capacity. These
cutting edge facilities include Hille 100 rolling mill, micro flexible rolling mill, thin foil rolling
mill, and micro cross wedge rolling mill. The Hille 100 rolling mills are integral to industry
applied research projects and higher degree research (HDR) theses, nourishing numerous
publications in top journals and conference proceedings, and contributing to advancements in
the metal rolling industry, and materials and manufacturing sciences and engineering. This visit
provided a timely and strategic opportunity for UOW and ARC Centre for Innovative Composites
for Sustainable Mining Equipment to further the collaborations of innovation-focused research.
      </div>
      </>
  },
    {
    date: "1-6 Feb 2026",
    description: "The ARC composites for Mining Equipment hosted AEPA 2026 in Auckland NZ",
    content: 
      <>
      <div>
        The 16th Asia-Pacific Symposium on Engineering Plasticity and its Applications (AEPA 2026) was held at Crowne Plaza, Auckland, New Zealand from 1 to 6 Feb 2026. The ARC Innovative Composites for Sustainable Mining Equipment at University of Wollongong (the Centre) was one of the four conference organizers and major sponsor for this year’s APEPA. AEPA 2026 focused on the areas of forming process, mechanics and modeling and process area.  AEPA 2026 in New Zealand finished the completeness of AEPA, and continues the previous successful AEPA Symposiums in Hong Kong (1992), Beijing (1994), Hiroshima (1996), Seoul (1998), Hong Kong (2000), Sydney (2002), Shanghai (2004), Nagoya (2006), Daejeon (2008), Wuhan (2010), Singapore (2012), Kaohsiung (2014), and Hiroshima (2016), Jeju (2018), Chengdu (2024).
      </div>
      <div>
        AEPA 2026 was a sounding success. The Centre Director, Distinguished Professor Zhengyi Jiang was a co-chair alongside the conference chair Professor Gow-Yi Tzou, two of the Centre HDR candidates/ associates Mr Muyuan Zhou and Ms Jingru Yan presented their work with excellent outcome, during the Conference oral presentation sessions. Both presentations attracted interest from both the Conference attendees and the steering committee members. 
      </div>
      <div>
        The home for 2026 AEPA was Auckland, a city famous for sightseeing and travelling. New Zealand consistently ranks highly in various global indices that measure factors such as quality of life, education, healthcare, political stability, and overall happiness.  We sincerely hope the next AEPA will be held in a city that matches the beauty of Auckland, such as Wollongong Australia.
      </div>
        <img src={image1} alt='conference' className='w-4/5 m-auto' />
        <img src={image2} alt='conference-muyuan' className='w-4/5 m-auto' />
        <img src={image3} alt='conference-jingru' className='w-4/5 m-auto' />
      </>
  },
      {
    date: "2-4 March 2026",
    description: "BAJC Conference 2026",
    content: 
      <>
      <div>
        The BAJC Conference 2026 of Baosteel-Australia Joint Research and Development Centre (BAJC) was held at the University of Queensland, in conjunction with 2026 BAJC Project Annual Review Meeting from 2-4 March 2026. UOW’s ARC Centre Director Distinguished Professor Jiang led the team attended this important conference and review meeting.
      </div>
      <div>
        During the one day of the conference, ARC Centre associated PhD candidates Muyuan Zhou, Jingru Yan, Afshana Morshed and Qian Wang,  and Postdoctoral fellows Drs Feijun Qu, Jenny Lin (UQ), and Weikang Lin (UQ) presented their highly industry focused work. The conference abstracts from all UOW and other institutes PhD candidates and Postdoctoral fellows were in included in the 2026 BAJC conference abstract book presented to the Baosteel delegates. Qian Wang received one of the PhD candidates best presentation awards. 
      </div>
      <div>
        On the second day of the conference, Distinguished Professor Zhengyi Jiang reported the progress of the two Baosteel projects to the BAJC/ technical committee including Baosteel senior delegates, both reports were positively commented by the committee members. Zhengyi’s presentations also attracted fresh collaboration interests from Baosteel senior delegates. 
      </div>
      <div>
        BAJC Conference 2026 fostered communication and collaboration among the researchers from participating institutions, namely UOW, UQ, Monash, UNSW and Deakin. The conference brought together the researchers working in the areas of interest to Baosteel to establish and further develop collaboration with Baosteel.  It provided an opportunity for all participating universities and their researchers to explore their innovation ideas and present their capacities to Baosteel. This paved the way for potential new research ventures, ripe for Baosteel grants via BAJC.
      </div>
        <img src={bajc1} alt='conference' className='w-4/5 m-auto' />
        <img src={bajc2} alt='conference-muyuan' className='w-4/5 m-auto' />
        <img src={bajc3} alt='conference-jingru' className='w-4/5 m-auto' />
        <img src={bajc4} alt='conference-muyuan' className='w-4/5 m-auto' />
        <img src={bajc5} alt='conference-jingru' className='w-4/5 m-auto' />
      </>
  },
        {
    date: "5 March 2026",
    description: "China Baowu Steel visited ARC Centre (Composites for Mining Equipment) at UOW",
    content: 
      <>
      <div>
        China Baowu Steel Group’s senior delegation visited UOW and its ARC Centre
(Composites for Mining Equipment) on 5 March 2026. During the visit, Baowu Steel
representatives and UOW representatives held a R&amp;D collaboration meeting followed
by a lab visit to UOW’s manufacturing hub led by Distinguished Professor Zhengyi Jiang.
      </div>
      <div>
        Baowu Steel senior delegation included Dr Jun Wu, Vice President of Baosteel and
President of the Baosteel Central Research Institute; Dr Sihai Jiao, Engineering Scientist
of China Baowu Steel Group Corporation Limited; Dr Na Wang, Senior Manager of
Science, Technology and Innovation Department and Dr Liangliang Guo, Deputy
Director of the Fundamental Research and Applied Innovation Center, Baosteel Central
Research Institute. UOW senior representatives included Professor Max Lu AO, VC and
President; Professor Alan Rowan, DVC Research and Innovation, and Dr Paul Di Pietro,
PVC Industry and Engagement and EIS senior academics such Distinguished Professor
Zhengyi Jiang, Senior Professors Michael Lerch, Huijun Li, and Haiping Du, and other
members of the Faculty. UOW’s strategic research partnership with Baosteel since
2007 has been led by Distinguished Professor Zhengyi Jiang, who delivered a
continuous pipeline of industry-funded research projects aligned with UOW’s global
leadership in materials science, advanced manufacturing, and steel innovation. To date,
the partnership has supported 12 major research projects, with a total Baosteel-related
funding exceeding AUD $3.28 million, in addition to significant co-investment through
Australian Research Council (ARC) Linkage and Industrial Transformation schemes.
This partnership directly supports Australia’s advanced manufacturing, hydrogen,
mining, and marine industries.
      </div>
      <div>
In addition to the existing research projects, Baosteel hope develop and strengthen the research collaboration in the areas such as 1) material characterization - surface
interface analysis, material service evaluation, precipitated phase analysis; 2) material
organization regulation technology ; 3) hydrogen embrittlement control technology; 4)
surface coating; 5) design and simulation technology; and 6) corrosion and protection,
etc, etc. Professor Max Lu also hosted a dinner banquet for our strategic industry
partner at Harbourfront Restaurant before the delegation departed Wollongong.
      </div>
        <img src={china1} alt='conference' className='w-4/5 m-auto' />
        <img src={chian2} alt='conference' className='w-4/5 m-auto' />
      </>
  },
          {
    date: "5 March 2026",
    description: "China Baowu Steel visited ARC Centre (Composites for Mining Equipment) at UOW",
    content: 
      <>
      <div>
        Congrats to our Centre ICHDR candidate Bahar Karamzadeh at UQ. Bahar recently
received the prestigious SPE Queensland Scholarship including $1,000 award. Bahar has
been serving as the Volunteer Secretary with SPE, and this award was in recognition of
her academic and voluntary activities within the community.
      </div>
      <div>
        We also want to thank Bahar’s two academic supervisors at UQ, Professors Peter
Knights and Mehmet Kizil for their mentorship for our HDR students.
      </div>
      <div>
Well done team ARC composites for mining equipment at UQ!
      </div>
        <img src={certificate} alt='certificate' className='w-4/5 m-auto' />
      </>
          },
  {
    date: "17 March 2026",
    description: "Well done Team WSU – Distinguished Professor Zhengyi Jiang visited WSU",
    content: 
      <>
      <div>
        ARC Center Composites for Mining Equipment Director Distinguished Professor Zhengyi Jiang led his
management team members visited Center Chief Investigator Professor Richard Yang at Western
Sydney University on 19 March 2026.
      </div>
      <div>
        After a discussion on Center ICHDR recruitment strategy and action plan meeting in his office,
Professor Yang took the Center management team to visit some of WSU’s whizz-bang engineering
laboratories which included generations of solar cars that won national and international awards
and prizes, industry scale 3D printer and 3D printers that are capable of producing high precision
objects and artifacts using recycled materials.
      </div>
      <div>
Professor Jiang congratulated Professor Yang’s recent promotion as the Interim Dean of Engineering
at WUS. The Centre wish Professor Yang every success in his research and professional leadership.
      </div>
       <div>
The visit concluded shortly after mid day.
      </div>
        <img src={WSU1703} alt='17March WSU trip' className='w-4/5 m-auto' />
      </>
  },
  {
    date: "28 Sept - 2 Oct 2026",
    description: "Creating impact from Wollongong",
    content: 
      <>
      <div>
Last week, the ARC ITTC Innovative Composites for the Future of Sustainable Mining
Equipment hosted the 9th International Symposium on Mine Safety Science and Engineering
(ISMSSE) and the Green Mining Conference 2026 has successfully concluded in
Wollongong, Australia, from 28 Sept to 2 Oct 2026. Over 220 experts, scholars, industry
representatives, and young researchers from China, Canada, the United States, the Czech
Republic, Japan, and Australia gathered to engage in in-depth exchanges on cutting-edge
topics including mine safety, green low-carbon development, intelligent mining, disaster
prevention and control, and sustainable development. UOW VIC and President Professor
Max Lu opened conference dinner on 1 October 2026.
      </div>
      <div>
This conference has arranged a total of 184 academic presentations, including 32 keynote
presentations and 88 standard academic presentations. The 9 th ISMSSE program
encompasses themes from green mining practices and sustainability, coal burst prevention
and mine hazard safety to Smart mining technologies and artificial intelligence (AI) and
Environmental impact, rehabilitation, and renewable energy integration. These fully
showcase the latest research achievements, technological advancements, and the talents of
young scholars in the fields of mining safety and green extraction. The conference is
particularly honoured to have welcomed Professors Wang Guofa, Huang Qingxue, Ge
Shirong, and Wu Aixiang, academicians of the Chinese Academy of Engineering, to attend.
Their presence and outstanding academic exchanges have significantly enhanced the
conference&#39;s scholarly influence and elevated the level of international engagement. On this
occasion, we extend our most sincere gratitude to these four academicians, as well as to all
experts and scholars who delivered exceptional presentations and actively participated in the
discussions.
      </div>
      <div>
Notably this year’s Higher Degree Research (HDR) Forum attracted over 60 high quality
students presentations. Sixteen of these young researchers have been awarded the
presentation awards. The HDR Forum provided these students and Early Career Researchers
with an opportunity to discuss mutual research interests, explore development and
collaboration opportunities.
      </div>
      <img src={conference021026} alt='02 Oct Conference' className='w-4/5 m-auto' />
      </>
          },
]